module.exports = __webpack_public_path__ + "img/Icon-upload-blue.afa31685.svg";